import axios from '../../axios'

/*
 * 成绩数据接口
 */

// 获取成绩列表
export const getScoreList = (data) => {
    return axios({
        url: '/api/mock/app/score',
        method: 'get',
        data
    })
}

// 编辑成绩信息 id
export const updateScore = (data) => {
    return axios({
        url: '/api/mock/app/score',
        method: 'put',
        data
    })
}

// 编辑成绩信息 id
export const deleteScore = (data) => {
    return axios({
        url: '/api/mock/app/score',
        method: 'delete',
        data
    })
}

// 导入成绩列表
export const importScore = (data) => {
    return axios({
        url: '/api/mock/app/import_score',
        method: 'post',
        data
    })
}

// 批量删除成绩列表
export const deleteBatchScore = (data) => {
    return axios({
        url: '/api/mock/app/delete_batch_score',
        method: 'delete',
        data
    })
}

// 发布成绩
export const updatePulish = (data) => {
    return axios({
        url: '/api/mock/app/publish',
        method: 'put',
        data
    })
}

// 图表数据查询
export const getScoreListByExam = (data) => {
    return axios({
        url: '/api/mock/app/score_stat',
        method: 'get',
        data
    })
}

// 扫描打分
export const scanSaveScore = (data) => {
    return axios({
        url: '/api/mock/app/scan_save_score',
        method: 'post',
        data
    })
}

export const exportScore = (data) => {
    return axios({
        url: '/api/mock/app/export_score',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/app/score.js